import { inject, injectable } from "inversify";
import { ISessionService } from "services/SessionService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

/* eslint @typescript-eslint/no-explicit-any: 0 */
@injectable()
export class CPLClientBase {
  @inject(SERVICE_TYPES.SessionService) sessionService!: ISessionService;

  protected async transformOptions(options: RequestInit) {
    const cplToken = await this.sessionService.getCPLSessionToken();
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${cplToken}`,
      Timeout: "300",
    };
    return await Promise.resolve(options);
  }

  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    // TODO: Return own result or throw exception to change default processing behavior,
    // or call processor function to run the default processing logic

    if (response.status == 401) {
      // log out user
      alert("401 - User should be logged out");
    }

    console.log("Service call: " + url);
    return processor(response);
  }

  protected getBaseUrl(defaultUrl: string, baseUrl?: string): string {
    if (baseUrl) {
      return baseUrl;
    }

    return process.env.REACT_APP_CPL_API_BASE_URI as string;
  }
}
